import { render, staticRenderFns } from "./HomeTitle.vue?vue&type=template&id=2f68705b&scoped=true&"
import script from "./HomeTitle.vue?vue&type=script&lang=ts&"
export * from "./HomeTitle.vue?vue&type=script&lang=ts&"
import style0 from "./HomeTitle.vue?vue&type=style&index=0&id=2f68705b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68705b",
  null
  
)

export default component.exports